import React, { useEffect } from 'react'
import translate from 'helpers/translate'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { SubContent } from './subcomponents'
import determinePersistResult from '../helpers/determinePersistResult'

interface ErrorMessageProps {
  errorCode: number
  errorDescriptor: string
}

const ErrorMessage = ({ errorCode, errorDescriptor }: ErrorMessageProps) => {
  const errorWithFindUser = errorCode === 1009 || errorCode === 1007
  const { analyticsSubFunction, errMsg, svcNum } =
    determinePersistResult(errorCode)

  useEffect(() => {
    if (errorWithFindUser) {
      triggerAnalyticsEvent({
        messageKey:
          'Error: It appears you recently updated your User ID. Please use your new User ID.'
      })
    } else {
      const errorText = translate({
        string: errMsg.key,
        argument: errMsg?.argument
      })

      triggerAnalyticsEvent({
        messageKey: `Error: ${errorText}`,
        subFunction: analyticsSubFunction,
        pageFunction: 'login_persistent'
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {errorWithFindUser ? (
        <SubContent>
          {translate({ string: 'recentlyUpdatedUserId' })}
        </SubContent>
      ) : (
        <SubContent>
          {errorCode === 500
            ? `${translate({
                string: errMsg.key,
                argument: errMsg?.argument
              })} (${errorDescriptor})`
            : translate({ string: errMsg.key, argument: errMsg?.argument })}
        </SubContent>
      )}
      {!errMsg?.argument && svcNum && (
        <SubContent>
          {translate({ string: 'persistErrorSubHeader', argument: svcNum })}
        </SubContent>
      )}
    </>
  )
}

export default ErrorMessage
